import HCLVertexState from '../HCLCellState/HCLVertexState';
import {mxCellRenderer, mxCellState} from "mxgraph-js";

abstract class HCLTreeMxCellRenderer extends mxCellRenderer {

  constructor() {
    super();
    this.registerShapes();
  }

  /**
   * register cell shapes for specific type of trees
   * Use {@function MxGraph.mxCellRenderer.registerShape} to register shapes
   * See {@link https://jgraph.github.io/mxgraph/docs/js-api/files/view/mxCellRenderer-js.html#mxCellRenderer.registerShape}
   * for more details
   */
  abstract registerShapes(): void;

  /**
   * Redraws the shape for the given cell state.
   * @param state {MxGraphType.mxCellState}
   * @param force {boolean}
   * @param rendering {boolean}
   */
  public redrawShape(state: mxCellState, force: boolean, rendering: boolean): boolean {
    if (state instanceof HCLVertexState) {
      state.handleTextInit(this);
      state.handleTextUpdate();
    }
    return super.redrawShape(state, force, rendering);
  }

  /**
   * Destroy the shape number
   * @param state {mxCellState}
   */
  public destroy(state: mxCellState): void {
    if (state instanceof HCLVertexState) {
      state.handleTextDestroy();
    }
    super.destroy(state);
  }
}

export default HCLTreeMxCellRenderer;
